import { Injectable } from '@angular/core';

import { InlineAddConfig, InlineAddField } from './inline-add-panel.component';

@Injectable({
  providedIn: 'root'
})
export class CustomerAddConfigService {
  
  getCustomerConfig(): InlineAddConfig {
    return {
      modelType: 'customer',
      title: 'Customer',
      apiEndpoint: 'api/customers/create',
      submitButtonText: 'Save',
      cancelButtonText: 'Cancel',
      fieldMapping: {
        'customerCode': 'code'
      },
      selectionConfig: {
        targetField: 'customerId',
        valueField: 'id',
        labelField: 'name'
      },
      fields: [
        {
          name: 'name',
          label: 'Customer Name',
          type: 'text',
          required: true,
          isInstantData: true,
          maxLength: 250,
          placeholder: 'Enter customer name',
          size: 'full'
        },
        {
          name: 'controlAccountId',
          label: 'Control Acc.',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select control account',
          size: 'half',
          searchConfig: {
            url: "api/accountcodes/search",
            searchFields: ['code', 'name'],
            defaultFilter: "IsActive eq true and SpecialCode eq 'DAC'"
          }
        },
        {
          name: 'customerCode',
          label: 'Customer Code',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Auto-generated by system',
          size: 'half'
        },
        {
          name: 'currencyId',
          label: 'Currency',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select currency',
          size: 'half',
          searchConfig: {
            url: 'api/currencies/lookup',
            searchFields: ['code'],
            defaultFilter: ''
          }
        },
        {
          name: 'termId',
          label: 'Term',
          type: 'select',
          required: true,
          options: [],
          placeholder: 'Select payment terms',
          size: 'half',
          searchConfig: {
            url: 'api/terms/lookup',
            searchFields: ['code', 'description'],
            defaultFilter: ''
          }
        },
        {
          name: 'agentId',
          label: 'Agent',
          type: 'select',
          required: false,
          options: [],
          placeholder: 'Select agent',
          size: 'half',
          searchConfig: {
            url: 'api/agents/lookup',
            searchFields: ['code', 'name']
          }
        }
       
      ]
    };
  }

  getTermsConfig(): InlineAddConfig {
    return {
      modelType: 'terms',
      title: 'Add New Terms',
      apiEndpoint: 'api/terms/create',
      submitButtonText: 'Save Terms',
      cancelButtonText: 'Cancel',
      selectionConfig: {
        targetField: 'termId',
        valueField: 'id',
        labelField: 'code'
      },
      fields: [
        {
          name: 'code',
          label: 'Code',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter terms code',
          size: 'full',
          isInstantData: true
        },
        {
          name: 'description',
          label: 'Description',
          type: 'text',
          required: false,
          maxLength: 250,
          placeholder: 'Enter terms description',
          size: 'full'
        },
        {
          name: 'type',
          label: 'Type',
          type: 'radio-group',
          required: true,
          options: [
            { label: 'Due in Days', value: 0 },
            { label: 'Due in Months', value: 1 }
          ],
          placeholder: 'Select type',
          size: 'half'
        },
        {
          name: 'value',
          label: 'Value',
          type: 'number',
          required: true,
          placeholder: 'Enter value',
          size: 'half'
        },
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half'
        }
      ],
      showMoreDetails: false
    };
  }

  getCustomerCategoryConfig(): InlineAddConfig {
    return {
      modelType: 'customerCategory',
      title: 'Add New Customer Category',
      apiEndpoint: 'api/customercategories/create',
      submitButtonText: 'Save Category',
      cancelButtonText: 'Cancel',
      selectionConfig: {
        targetField: 'categoryId',
        valueField: 'id',
        labelField: 'code'
      },
      fields: [
        {
          name: 'code',
          label: 'Code',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter category code',
          size: 'full',
          isInstantData: true
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: false,
          maxLength: 250,
          placeholder: 'Enter category name',
          size: 'full'
        },
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half',
          defaultValue: false
        }
      ],
      showMoreDetails: false
    };
  }

  getAgentConfig(): InlineAddConfig {
    return {
      modelType: 'agent',
      title: 'Add New Agent',
      apiEndpoint: 'api/agents/create',
      submitButtonText: 'Save Agent',
      cancelButtonText: 'Cancel',
      selectionConfig: {
        targetField: 'agentId',
        valueField: 'id',
        labelField: 'code'
      },
        hiddenData: {
        isActive: true,
      },
      fields: [
        {
          name: 'code',
          label: 'Agent #',
          type: 'text',
          required: true,
          maxLength: 50,
          placeholder: 'Enter agent number',
          size: 'full',
          isInstantData: true
        },
        {
          name: 'name',
          label: 'Name',
          type: 'text',
          required: true,
          maxLength: 250,
          placeholder: 'Enter agent name',
          size: 'full'
        },
        {
          name: 'isDefault',
          label: 'Default',
          type: 'switch',
          required: false,
          size: 'half',
          defaultValue: false
        }
      ]
    };
  }
} 